import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import RangeSlider from '/@/components/forms/range-slider';
import Section from '/@/components/section';
import Title from '/@/components/title';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { formatEnvironmentRange } from '/@/utils';
import Select from '/@/v3/components/forms/select';

import styles from './styles.module.css';

@autobind
export default class CornConfiguration extends Component {
    static contextTypes = {
        units: PropTypes.object.isRequired,
    };

    render() {
        const {
            zone,
            zoneOptions,
            setZone,
            head,
            headOptions,
            setHead,
            environment,
            environments,
            environmentType,
            setEnvironment,
        } = this.props;

        return (
            <Section title={_('Head to head')}>
                <div className={styles.filters}>
                    {zone && zoneOptions.length > 1 && (
                        <div className={styles.filter}>
                            <Title>{_('Zona')}</Title>
                            <Select
                                placeholder={_('Seleccioná la zona')}
                                clearable={false}
                                value={zone}
                                options={zoneOptions}
                                onChange={setZone}
                                color={settings.app.theme}
                                maxHeight='500px'
                            />
                        </div>
                    )}
                    <div className={styles.filter}>
                        <Title>{_('Head')}</Title>
                        <Select
                            clearable={false}
                            placeholder={_('Seleccioná el híbrido head')}
                            value={head}
                            options={headOptions}
                            onChange={setHead}
                            color={settings.app.theme}
                        />
                    </div>
                    {environmentType === 'options' && environments.options.length > 0 && (
                        <div className={styles.filter}>
                            <Title>{_('Ambiente')}</Title>
                            <Select
                                placeholder={_('Seleccioná el ambiente')}
                                clearable={false}
                                value={environment}
                                options={environments.options.map((environment) => ({
                                    value: { min: environment[0], max: environment[1] },
                                    label: formatEnvironmentRange(
                                        { min: environment[0], max: environment[1] },
                                        (value) => this.context.units.toYield(value, 'corn')
                                    ),
                                }))}
                                onChange={(value) => setEnvironment(value)}
                                color={settings.app.theme}
                                maxHeight='500px'
                            />
                        </div>
                    )}
                    {environmentType === 'slider' && (
                        <div className={classNames(styles.filter, styles.environmentRange)}>
                            <Title>{_('Ambiente')}</Title>
                            <RangeSlider
                                step={100}
                                min={Math.round(environments.minEnvironment / 100) * 100}
                                max={Math.round(environments.maxEnvironment / 100) * 100}
                                innerMin={Math.round(environments.maxEnvironment / 100) * 100}
                                innerMax={Math.round(environments.minEnvironment / 100) * 100}
                                value={[environment.min, environment.max]}
                                unit={this.context.units.getUnit('yield', 'corn')}
                                format={(value) => this.context.units.toYield(value, 'corn').value}
                                onChange={(value) => setEnvironment({ min: value[0], max: value[1] })}
                            />
                        </div>
                    )}
                </div>
            </Section>
        );
    }
}
